<template>
  <div ref="carousel" :class="`carousel ${name}`" v-if="payload">
    <div class="carousel__slide" v-for="(img,i) in computedPayload" :key="i">
      <a :data-fancybox="`${name}-${randomId}`" :data-src="doCheck(img)" :data-alt="doCheck(img,i)">
        <div class="thumbnail" :style="`background-image: url(${doCheck(img)});`"></div>
      </a>
    </div>
  </div>
</template>

<script>
import { Fancybox, Carousel } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

export default {
  name: 'CarouselGallery',

  components: {
    Fancybox,
    Carousel
  },

  props: {
    payload: {
      type: [Object,String],
    },
    name: {
      type: String,
      default: 'esc-carousel'
    },
    alt: {
      type: String,
      default: 'Gallery image'
    }
  },

  mounted() {  
    this.initCarousel();
    this.initFancybox();
  },

  data() {
    return {
      settings: {
        carousel: {
          'Navigation': false,
          'Dots': false,
          'infinite': false,
          'center': false,
          'fill' : true,
          'slidesPerPage': 1
        },
        fancybox: {
          'infinite': false
        }
      }
    }
  },
  
  methods: {
    initCarousel() {
      new Carousel(this.$refs.carousel, this.settings.carousel);
    },
    initFancybox() {
      Fancybox.bind(`[data-fancybox="${this.name}"]`, this.settings.fancybox);
    },
    doCheck(data, index) {
      let result;
      if(index === undefined) {
        result = typeof data == 'string' ? data : data.path;
      } else {
        result = typeof data == 'string' ? `${this.alt} ${index}` : data.alt;
      }
      return result;
    }
  },

  computed: {
    computedPayload() {
      return typeof this.payload === 'string' ? JSON.parse(this.payload) : this.payload;
    },
    randomId() {
      return Math.random().toString(36).substr(2, 5) + Date.now();
    },
  }
}
</script>
